import Cookies from 'js-cookie';
import CryptoJS from 'crypto-js';

// Secret key for AES encryption
const secretKey = 'your-secret-key';

// Function to get the base domain dynamically
const getBaseDomain = () => {
    const domain = window.location.hostname;
    const parts = domain.split('.');

    // Assuming the base domain is the last two parts of the hostname (e.g., "example.com" from "sub1.example.com")
    const baseDomain = parts.slice(-2).join('.');
    return baseDomain;
};

export const setEncryptedCookie = (name, value, options) => {
    if (value === undefined || value === null || value === '') {
        console.error('Cannot encrypt and set cookie: Value is invalid (undefined, null, or empty).');
        return;
    }

    try {
        // Encrypt the cookie value using AES
        const encryptedValue = CryptoJS.AES.encrypt(String(value), secretKey).toString();

        // Get the base domain dynamically
        const baseDomain = getBaseDomain();

        // Set the cookie with the base domain and other options
        Cookies.set(name, encryptedValue, {
            ...options,
            domain: `.${baseDomain}` // Set the base domain for the cookie
        });
    } catch (error) {
        console.error('Error setting encrypted cookie:', error);
    }
};

export const getDecryptedCookie = (name) => {
    try {
        const encryptedValue = Cookies.get(name);
        if (!encryptedValue) return null;

        // Decrypt the cookie value using AES
        const bytes = CryptoJS.AES.decrypt(encryptedValue, secretKey);
        const decryptedValue = bytes.toString(CryptoJS.enc.Utf8);

        if (!decryptedValue) {
            console.error('Decryption failed for cookie:', name);
            return null;
        }

        return decryptedValue;
    } catch (error) {
        console.error('Error getting decrypted cookie:', error);
        return null;
    }
};

export const removeCookie = (name) => {
    try {
        // Get the base domain dynamically
        const baseDomain = getBaseDomain();

        // Remove the cookie by setting the domain to the base domain
        Cookies.remove(name, { domain: `.${baseDomain}` });
    } catch (error) {
        console.error('Error removing cookie:', error);
    }
};

export const setCookie = (name, value, days = 7) => {
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000); // Expiry time

    // Get the base domain dynamically
    const baseDomain = getBaseDomain();

    // Set the cookie for the base domain
    document.cookie = `${name}=${value}; expires=${expires.toUTCString()}; path=/; domain=.${baseDomain}`;
};

export const getCookie = (name) => {
    const nameEQ = `${name}=`;
    const cookies = document.cookie.split(';');

    for (let cookie of cookies) {
        cookie = cookie.trim();
        if (cookie.startsWith(nameEQ)) {
            return cookie.substring(nameEQ.length);
        }
    }
    return null;
};

export const removeSSOCookie = (name) => {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;
};
